import { styledPolymorphic } from '@qred/components-library';

export const Grid = styledPolymorphic<
  'div',
  {
    $itemMinWidth?: string;
  }
>()((styled) =>
  styled(({ $itemMinWidth = '200px' }) => ({
    width: '100%',
    display: 'grid',
    gap: '16px',
    gridTemplateColumns: `repeat(auto-fit, minmax(${$itemMinWidth}, 1fr))`,
  }))
);
